import { render, staticRenderFns } from "./audience-home.vue?vue&type=template&id=5cb9d524&scoped=true&"
import script from "./audience-home.vue?vue&type=script&lang=js&"
export * from "./audience-home.vue?vue&type=script&lang=js&"
import style0 from "./audience-home.vue?vue&type=style&index=0&id=5cb9d524&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb9d524",
  null
  
)

export default component.exports